/*
Structure of an MediaObjectin Builder Format
	{
		BtnId: '5acf3762a6253c32f57e8b46',

		FileType: 'Audio',
		Title: {
			de: 'Titel der Audiospur',
			en: false,
		},
		Alt: {
			de: false,
			en: false,
		},
		Desc: {
			de: 'enter text',
			en: false,
		},
		Sources: {
			de: '../media-5ad454a6050d2f13289bed3a/Gold-history-de.mp3',
			en: '../media-5ad454a6050d2f13289bed3a/Gold-history-de.mp3',
		},
		Ratio: {},
		Duration: {
			de: 26.566531,
			en: 26.566531,
		},
		DurationHR: {
			de: '0:27',
			en: '0:27',
		},
		BigSources: {},
		ThumbSources: {},
			Thumb: {},
	};
*/
import { actionTypes } from '../../../types';
export default (store) => {
	window.nativeOnAudioPlay = ({ mediaObject, position }) => {
		store.dispatch(actionTypes.audioLoadAndPlay, { mediaObject, position });
	};
};
